import { DynamicIcon } from 'phosphor-icons/react';
import { c } from '../../../utils/tailwind-merge';
import { ProductBreadcrumbsProps } from './ProductBreadcrumbs.types';

export const ProductBreadcrumbs = ({
  path,
  className = '',
}: ProductBreadcrumbsProps) => {
  return (
    <nav aria-label="Breadcrumb">
      <ul
        className={c('mb-4 flex flex-wrap items-center', className)}
        data-test="product-breadcrumbs-list"
      >
        {path.map((item, index) => {
          const isLastItem = index === path.length - 1;
          const base =
            'self-stretch p-1 text-xxs font-normal uppercase leading-[20px] tracking-[1.2px] transition-colors';
          const text = isLastItem ? 'text-grey-900' : 'text-grey-600';
          return (
            <li className="flex items-center" key={item.slug}>
              {isLastItem ? (
                <span className={`${base} ${text}`} aria-current="page">
                  {item.name}
                </span>
              ) : (
                <a
                  href={
                    item.slug === '/'
                      ? '/'
                      : `/${item.slug.replace(/^\/+/, '')}`
                  }
                  className={`${base} ${text}`}
                >
                  {item.name}
                </a>
              )}
              {!isLastItem && (
                <DynamicIcon
                  className="ml-[8px] mr-[4px] fill-grey-400"
                  height={16}
                  width={16}
                  iconName="CaretRight"
                  aria-hidden="true"
                />
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
